const DRAFT = { id: 'DRAFT', name: 'Draf', label: 'delivery.status.draft' }
const CONFIRMED = { id: 'CONFIRMED', name: 'Dikonfirmasi', label: 'delivery.status.confirmed' }
const SCHEDULED = { id: 'SCHEDULED', name: 'Dijadwalkan', label: 'delivery.status.scheduled' }
const RESCHEDULED = { id: 'RESCHEDULED', name: 'Dijadwalkan Ulang', label: 'delivery.status.rescheduled' }
const STARTED = { id: 'STARTED', name: 'Dijalankan', label: 'delivery.status.started' }
const PICKED = { id: 'PICKED', name: 'Diambil', label: 'delivery.status.picked' }
const DELIVERED = { id: 'DELIVERED', name: 'Terkirim', label: 'delivery.status.delivered' }
const CANCELED = { id: 'CANCELED', name: 'Dibatalkan', label: 'delivery.status.canceled' }
const WAITING_FOR_VENDOR = {
  id: 'WAITING_FOR_VENDOR',
  name: 'Kirim ke Vendor',
  label: 'delivery.status.waiting_for_vendor',
  tooltip: 'Hapus Nama Vendor bila ingin melakukan penugasan biasa',
}

const status = {
  DRAFT,
  CONFIRMED,
  SCHEDULED,
  RESCHEDULED,
  STARTED,
  PICKED,
  DELIVERED,
  CANCELED,
  WAITING_FOR_VENDOR,
}

export const statusNameToIdMap = {
  [DRAFT.name]: DRAFT.id,
  [CONFIRMED.name]: CONFIRMED.id,
  [SCHEDULED.name]: SCHEDULED.id,
  [RESCHEDULED.name]: RESCHEDULED.id,
  [STARTED.name]: STARTED.id,
  [PICKED.name]: PICKED.id,
  [DELIVERED.name]: DELIVERED.id,
  [CANCELED.name]: CANCELED.id,
  [WAITING_FOR_VENDOR.name]: WAITING_FOR_VENDOR.id,
}

export const statusIdToNameMap = {
  [DRAFT.id]: DRAFT.name,
  [CONFIRMED.id]: CONFIRMED.name,
  [SCHEDULED.id]: SCHEDULED.name,
  [RESCHEDULED.id]: RESCHEDULED.name,
  [STARTED.id]: STARTED.name,
  [PICKED.id]: PICKED.name,
  [DELIVERED.id]: DELIVERED.name,
  [CANCELED.id]: CANCELED.name,
  [WAITING_FOR_VENDOR.id]: WAITING_FOR_VENDOR.name,
}

export const statusIdToLabelMap = {
  [DRAFT.id]: DRAFT.label,
  [CONFIRMED.id]: CONFIRMED.label,
  [SCHEDULED.id]: SCHEDULED.label,
  [RESCHEDULED.id]: RESCHEDULED.label,
  [STARTED.id]: STARTED.label,
  [PICKED.id]: PICKED.label,
  [DELIVERED.id]: DELIVERED.label,
  [CANCELED.id]: CANCELED.label,
  [WAITING_FOR_VENDOR.id]: WAITING_FOR_VENDOR.label,
}

export default status
